import Component, { mixins } from "vue-class-component";
import { ApplicationUserRoleMixin } from "@/mixins";

@Component
export class PowerBiUserRoleMixin extends mixins(ApplicationUserRoleMixin) {
    async mounted(): Promise<void> {
        await this.$store.dispatch("powerbi/loadValidators");
    }
}
